import { FC } from 'react'
import { InfoCircleOutlined } from '@ant-design/icons'
import { Tooltip } from 'antd'
import classNames from 'classnames'
import { declOfNum } from '@/helpers/declOfNum'
import {
  COURSE_INDICATORS_SETTINGS_PATH,
  getResolvedCourseDemoPeriodInfo,
} from '@/helpers/courseIndicators'
import cn from './index.module.css'

interface IDemoPeriodBadge {
  order?: Record<string, any> | null
  className?: string
  compact?: boolean
  studentSummary?: boolean
}

const DemoPeriodBadge: FC<IDemoPeriodBadge> = ({
  order,
  className,
  compact = false,
  studentSummary = false,
}) => {
  const demo = getResolvedCourseDemoPeriodInfo(order)

  if (!demo.isDemo) return null

  const tooltipTitle = (
    <div className={cn.tooltip}>
      <b>{demo.isExpired ? 'Демо-период завершён' : 'Демо-период активен'}</b>
      {studentSummary && (
        <span>У учащегося есть курс или класс с демо-периодом.</span>
      )}
      {demo.startDate && <span>Начало: {demo.startDate}</span>}
      {demo.endDate && <span>Окончание: {demo.endDate}</span>}
      {!demo.isExpired && demo.remainingDays !== null && (
        <span>
          Осталось: {demo.remainingDays}{' '}
          {declOfNum(demo.remainingDays, ['день', 'дня', 'дней'])}
        </span>
      )}
      <a
        href={COURSE_INDICATORS_SETTINGS_PATH}
        className={cn.tooltipLink}
        onClick={(event) => event.stopPropagation()}
      >
        Настройки отметок
      </a>
    </div>
  )

  return (
    <Tooltip title={tooltipTitle} mouseEnterDelay={0} placement="top">
      <span
        className={classNames(
          cn.badge,
          compact && cn.compact,
          demo.isExpired && cn.expired,
          className,
        )}
        tabIndex={0}
      >
        Демо-период
        <InfoCircleOutlined
          onPointerEnterCapture={undefined}
          onPointerLeaveCapture={undefined}
        />
      </span>
    </Tooltip>
  )
}

export default DemoPeriodBadge
